<template>
  <div>
    <v-expand-transition>
      <v-card v-if="showFeedbackWidget">
        <v-card-title class="subtitle-1">
          {{ $t('survey-link-title') }}
        </v-card-title>
        <v-card-text class="text-left subtitle-2">
          {{ $t('survey-link-description') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            id="survey-link-button"
            color="primary"
            :to="surveyLink"
            target="_blank"
            class="text-capitalize"
            @click="closeClick"
          >
            {{ $t('survey-link-button') }}
          </v-btn>
        </v-card-actions>
        <v-btn
          id="close-survey-button"
          fab
          small
          absolute
          top
          right
          class="close-widget-btn"
          color="white"
          elevation="0"
          @click="closeClick"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card>
    </v-expand-transition>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { ADD_PARTICIPATED_SURVEY } from '@/store/action-types'
import {
  HAS_PARTICIPATED_IN_SURVEY,
  GET_ORDER_CONFIRMATION
} from '@/store/get-types'
import { getNonExistingRouteNameEquivalent } from '@/router/routes/utilities'
import { USABILLA_ORDER_COMPLETION_FEEDBACK_WIDGET_ID } from '@/components/shared/feedback/feedback-constants'
import { SURVEY_ROUTE } from '@/router/routes/route-names'

export default {
  name: 'SurveyLink',
  data () {
    return {
      widgetId: USABILLA_ORDER_COMPLETION_FEEDBACK_WIDGET_ID,
      showFeedbackWidget: false
    }
  },
  computed: {
    ...mapGetters({
      participatedSurvey: HAS_PARTICIPATED_IN_SURVEY,
      orderConfirmation: GET_ORDER_CONFIRMATION
    }),
    userHasParticipated () {
      return this.participatedSurvey(this.widgetId)
    },
    surveyLink () {
      const { referenceOrderID } = this.orderConfirmation
      const route = {
        name: getNonExistingRouteNameEquivalent({ name: SURVEY_ROUTE }),
        params: {
          widgetId: this.widgetId,
          referenceOrderID
        }
      }
      return route
    }
  },
  mounted () {
    // user has not yet interacted with widget, so show it
    if (!this.userHasParticipated) {
      this.showFeedbackWidget = true
    }
  },
  methods: {
    ...mapActions({
      addParticipatedSurvey: ADD_PARTICIPATED_SURVEY
    }),
    closeClick () {
      // user does not want to participate
      this.addParticipatedSurvey(this.widgetId)
      this.showFeedbackWidget = false
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .close-widget-btn {
    /* move close button to exactly top-right corner */
    top: 0 !important;
    right: 0 !important;
  }
}
</style>
